import { Icon, IconSize, IconType, Tooltip } from "@dexibit/core";
import { faMessage, faUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { useSelector } from "react-redux";

import appConfig from "../../config";
import { selectUnreadCount } from "../../store/services/intercom";
import {
  MessengerDecoration,
  NavItemIcon,
  NavItemLabel,
  NavItemRow,
  UnreadBadge,
} from "./styles";

interface NavSupportProps {
  isExpanded: boolean;
}

export const NavSupport = ({ isExpanded }: NavSupportProps) => {
  const unreadCount = useSelector(selectUnreadCount);

  const onSupportClick = () => {
    window.open(appConfig.supportCentreUrl, "_blank");
  };

  const onMessengerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const supportIcon = (
    <NavItemIcon>
      <Icon type={IconType.fa} icon={faUpRightFromSquare} size={IconSize.xs} />
    </NavItemIcon>
  );

  return (
    <NavItemRow
      isActive={false}
      onClick={onSupportClick}
      data-cy="support-center-nav-item"
    >
      {!isExpanded ? (
        <Tooltip title="Support center" placement="right">
          <span style={{ display: "flex" }}>{supportIcon}</span>
        </Tooltip>
      ) : (
        supportIcon
      )}
      <NavItemLabel isExpanded={isExpanded}>Support center</NavItemLabel>
      <MessengerDecoration
        id="support_messenger"
        isExpanded={isExpanded}
        onClick={onMessengerClick}
        data-cy="support-messenger-nav-item"
      >
        <Icon type={IconType.fa} icon={faMessage} size={IconSize.xs} />
        {unreadCount ? <UnreadBadge>{unreadCount}</UnreadBadge> : null}
      </MessengerDecoration>
    </NavItemRow>
  );
};
